export default {
  createdAt: 'Creado el',
  lastModifiedAt: 'Modificado el',
};
